<template>
  <el-dialog
    title="缴费详情"
    v-if="visible"
    :visible.sync="visible"
    width="80%"
    :append-to-body="true"
  >
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="shouldAmount" slot-scope="scope">
        <span>{{ tool.money_format_allowvoid(scope.row.shouldAmount) }}</span>
      </template>
      <template slot="delayAmount" slot-scope="scope">
        <span>{{ tool.money_format_allowvoid(scope.row.delayAmount) }}</span>
      </template>
      <template slot="accountpayAmount" slot-scope="scope">
        <span>{{ tool.money_format_allowvoid(scope.row.accountpayAmount) }}</span>
      </template>
      <template slot="derateAmount" slot-scope="scope">
        <span>{{ tool.money_format_allowvoid(scope.row.derateAmount) }}</span>
      </template>
      <template slot="depositAmount" slot-scope="scope">
        <span>{{ tool.money_format_allowvoid(scope.row.depositAmount) }}</span>
      </template>
      <template slot="payAmount" slot-scope="scope">
        <span>{{ tool.money_format_allowvoid(scope.row.payAmount) }}</span>
      </template>
    </avue-crud>
  </el-dialog>
</template>
<script>
import { payListPageByFeePayId } from '@/api/v4ward/paylist/feepaylist';

export default {
  props: {
    id: '',
    visible: false,
  },
  data() {
    return {
      data: [],
      option: {
        index: true,
        indexLabel: '序号',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'center',
        refreshBtn: false,
        viewBtn: false,
        searchBtn: false,
        columnBtn: false,
        searchShowBtn: false,
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '地址',
            prop: 'roomName',
          },
          {
            label: '费项类别',
            prop: 'feeSortName',
          },
          {
            label: '收费周期',
            prop: 'billcycleNo',
          },
          {
            label: '缴费人',
            prop: 'householdName',
          },
          {
            label: '收费时间',
            prop: 'payTime',
            type: 'date',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '应收金额',
            prop: 'shouldAmount',
            slot: true,
            align: 'right',
          },
          {
            label: '滞纳金',
            prop: 'delayAmount',
            slot: true,
            align: 'right',
          },
          {
            label: '抵扣金额',
            prop: 'accountpayAmount',
            slot: true,
            align: 'right',
          },
          {
            label: '优惠金额',
            prop: 'derateAmount',
            slot: true,
            align: 'right',
          },
          {
            label: '押金抵扣金额',
            prop: 'depositAmount',
            slot: true,
            align: 'right',
          },
          {
            label: '收费金额',
            prop: 'payAmount',
            slot: true,
            align: 'right',
          },
          {
            label: '支付方式',
            prop: 'payType',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=pay_type',
            dataType: 'number',
          },
          {
            label: '收款人',
            prop: 'cashierName',
          },
          {
            label: '票据号',
            prop: 'invoiceNo',
          },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
    };
  },
  watch: {
    visible() {
      this.$emit('update:visible', this.visible);
    },
  },
  methods: {
    onLoad(page) {
      if (this.id) {
        this.loading = true;
        page = page || this.page;
        payListPageByFeePayId({
          current: page.currentPage,
          size: page.pageSize,
          radio: 1,
          feePayId: this.id,
        })
          .then(({ data }) => {
            this.page.total = data.ipage.total;
            this.data = data.ipage.records || [];
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
